const SalesNews = () => {
   return (
      <svg width="18" height="18" fill="none" viewBox="0 0 18 18">
         <path stroke="#146EF5" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1.3" d="M11.546 16H2V5.182h11.454"></path>
         <path stroke="#146EF5" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1.3" d="M5.182 7.09V4.546a2.546 2.546 0 015.09 0v2.546M11.545 13.456H9.636v-1.91l3.819-3.817 1.909 1.909-3.819 3.818z">
         </path>
      </svg>
   )
}
export default SalesNews;